module.exports = __webpack_public_path__ + "static/media/sound-new-thread.60fb1724.mp3";